module.exports = __webpack_public_path__ + "img/20190724153245QQ截图20190723235805.d38764ad.png";